import httpClient from '@/api/httpClient';
const BASE_URL = '/api/payment';

const generateCode = (orderId, payload) => httpClient.post(`${BASE_URL}/ghQr/${orderId}`, payload);
export {
  generateCode
};
